import {
  SideBarStudentItem,
  StudentSideBarItemType,
} from './componenets/side-bar-student-item';
import React from 'react';
export interface SideBarAdministrationModel {
  onClick: (type: StudentSideBarItemType) => void;
  selectedType?: StudentSideBarItemType;
}
export const SideBarAdministration: React.FC<SideBarAdministrationModel> = ({
  onClick,
  selectedType,
}) => {
  return (
    <div style={{ width: '250px', marginLeft: '16px' }}>
      <SideBarStudentItem
        type={StudentSideBarItemType.PROFILE}
        text={'פרטים אישיים'}
        onClick={onClick}
        isSelected={selectedType === StudentSideBarItemType.PROFILE}
      />

      <SideBarStudentItem
        type={StudentSideBarItemType.PERMISSIONS}
        text={'ממשק משתמש'}
        onClick={onClick}
        isSelected={selectedType === StudentSideBarItemType.PERMISSIONS}
      />
    </div>
  );
};
